/*
 * sc-collection-dots-fix.js  —  Vogain (31aab4-2) theme patch, store-scoped.
 *
 * The ScaleChart app setting is "Colour dots", so EVERY collection swatch must
 * be a SOLID colour dot — never a letter, never a photo thumbnail.
 *
 * ScaleChart resolves common colour names itself. This patch only handles the
 * values it can't name (marketing names on the floral / print dresses —
 * "Dusty Blossom", "Tea Garden", …), which it renders as a grey circle with the
 * colour's first letter. For each of those we sample that colour's variant
 * photo and paint the dot a single representative solid colour. If the photo
 * can't be read we still use a solid neutral — we never fall back to a
 * thumbnail or a letter.
 *
 * It only ever touches spans ScaleChart rendered ([data-sc-coll-dots]) that are
 * NOT already a proper colour dot, so resolved dots and the "+N" pill are left
 * alone.
 */
(function () {
  'use strict';
  if (window.__scDotFix) return;
  window.__scDotFix = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var COLOR_RE = /^(colou?r|farbe|couleur|kleur|colore|farve|f(a|ä)rg|väri|cor|szín|barva|farba|kolor|renk)$/i;
  var prodCache = {};  // handle  -> { map:{valueLower:imgSrc}, pending:bool }
  var tintCache = {};   // imgSrc  -> 'rgb(...)' | null   (null = sampled, unreadable)

  function isListingPage() {
    try {
      var pt = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.pageType;
      if (pt) return String(pt).toLowerCase() !== 'product';
    } catch (e) {}
    return !/\/products\/[^\/?#]+/.test(location.pathname);
  }

  // Average vivid colour of the centre of an image -> a single solid rgb().
  function solidTint(url, cb) {
    if (tintCache[url] !== undefined) { cb(tintCache[url]); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var n = 24;
        var cv = document.createElement('canvas'); cv.width = n; cv.height = n;
        var ctx = cv.getContext('2d');
        var iw = img.naturalWidth || n, ih = img.naturalHeight || n;
        ctx.drawImage(img, iw * 0.2, ih * 0.2, iw * 0.6, ih * 0.6, 0, 0, n, n);
        var d = ctx.getImageData(0, 0, n, n).data;
        var r = 0, g = 0, b = 0, c = 0, i;
        for (i = 0; i < d.length; i += 4) {
          if (d[i + 3] < 128) continue;
          var R = d[i], G = d[i + 1], B = d[i + 2];
          var mx = Math.max(R, G, B), mn = Math.min(R, G, B), l = (mx + mn) / 2;
          if ((mx - mn) < 20 || l > 238 || l < 20) continue; // skip washed / near-white / near-black
          r += R; g += G; b += B; c++;
        }
        if (!c) { // photo is all pale — take a plain mean of everything visible
          for (i = 0; i < d.length; i += 4) { if (d[i + 3] < 128) continue; r += d[i]; g += d[i + 1]; b += d[i + 2]; c++; }
        }
        var out = c ? 'rgb(' + Math.round(r / c) + ',' + Math.round(g / c) + ',' + Math.round(b / c) + ')' : null;
        tintCache[url] = out; cb(out);
      } catch (e) { tintCache[url] = null; cb(null); }
    };
    img.onerror = function () { tintCache[url] = null; cb(null); };
    img.src = url;
  }

  function paintSolid(span, color) {
    span.textContent = '';
    span.style.setProperty('background', color, 'important');
    span.style.setProperty('background-image', 'none', 'important');
    span.style.color = 'transparent';
    span.setAttribute('data-sc-dotfix-done', '1');
  }

  function colorMapFromProduct(prod) {
    var map = {};
    if (!prod || !prod.options || !prod.variants) return map;
    var names = prod.options.map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    var idx = -1;
    for (var i = 0; i < names.length; i++) { if (COLOR_RE.test((names[i] || '').trim())) { idx = i; break; } }
    if (idx < 0 && names.length === 1) idx = 0;
    if (idx < 0) return map;
    var firstImg = '';
    if (typeof prod.featured_image === 'string') firstImg = prod.featured_image;
    else if (prod.featured_image && prod.featured_image.src) firstImg = prod.featured_image.src;
    if (!firstImg && prod.images && prod.images.length) {
      var f0 = prod.images[0]; firstImg = typeof f0 === 'string' ? f0 : (f0 && f0.src) || '';
    }
    prod.variants.forEach(function (v) {
      var val = v.options ? v.options[idx] : v['option' + (idx + 1)];
      if (!val) return;
      var k = String(val).toLowerCase();
      if (map[k]) return;
      map[k] = (v.featured_image && v.featured_image.src) || firstImg || '';
    });
    return map;
  }

  // A dot that still needs fixing: ScaleChart rendered it (span[title]) but it is
  // NOT a finished colour dot — it shows a letter, or an image background.
  function needsFix(span) {
    if (span.getAttribute('data-sc-dotfix-done') === '1') return false;
    if ((span.textContent || '').trim()) return true;
    var bi = '';
    try { bi = getComputedStyle(span).backgroundImage || ''; } catch (e) {}
    return bi.indexOf('url(') !== -1; // an image/thumbnail fill (incl. an earlier build's)
  }

  function fixRow(row) {
    var all = row.querySelectorAll('span[title]');
    var pending = [];
    for (var i = 0; i < all.length; i++) if (needsFix(all[i])) pending.push(all[i]);
    if (!pending.length) { row.setAttribute('data-sc-dotfix', '1'); return; }

    var card = row.closest('.product-card, [class*="product-card"], .card, .grid__item, .product-item, li, article');
    var link = (card || row.parentElement || row).querySelector('a[href*="/products/"]');
    if (!link && card) link = card.closest('a[href*="/products/"]');
    var m = link && (link.getAttribute('href') || '').match(/\/products\/([a-zA-Z0-9_-]+)/);
    if (!m) return;
    var handle = m[1];

    var apply = function (map) {
      pending.forEach(function (d) {
        var src = map[(d.getAttribute('title') || '').toLowerCase()];
        if (!src) { paintSolid(d, '#d9d9d9'); return; } // no photo at all -> solid neutral, never a letter
        var sampleUrl = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        solidTint(sampleUrl, function (color) { paintSolid(d, color || '#d9d9d9'); });
      });
      row.setAttribute('data-sc-dotfix', '1');
    };

    if (prodCache[handle] && prodCache[handle].map) { apply(prodCache[handle].map); return; }
    if (prodCache[handle] && prodCache[handle].pending) return;
    prodCache[handle] = { pending: true };
    fetch(ROOT + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (prod) { prodCache[handle] = { map: colorMapFromProduct(prod) }; apply(prodCache[handle].map); })
      .catch(function () { prodCache[handle] = { map: {} }; apply({}); });
  }

  function scan() {
    if (!isListingPage()) return;
    var rows = document.querySelectorAll('[data-sc-coll-dots]');
    for (var i = 0; i < rows.length; i++) fixRow(rows[i]);
  }

  var t = null;
  function schedule() { if (t) return; t = setTimeout(function () { t = null; scan(); }, 120); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  // ScaleChart injects the dots asynchronously and the theme re-renders the grid
  // on filter / sort / paginate — watch for both, plus a short poll while the
  // dots stream in on first load.
  try {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
  var n = 0, iv = setInterval(function () { scan(); if (++n > 20) clearInterval(iv); }, 400);
})();
